export default __webpack_public_path__ + "static/media/RotaryCoils.fa6ff43d.svg";